export default __webpack_public_path__ + "static/media/capegreen.7cbd5481.svg";